import { ReactNode } from 'react'

interface ToggleProps {
  label: string
  toggleLabel: string
  isChecked: boolean
  onToggle: () => void
  children?: ReactNode
  error?: string
}

export const Toggle = ({ label, toggleLabel, isChecked, onToggle, children, error }: ToggleProps): JSX.Element => {
  return (
    <div className="flex-1">
      <label className="block subtitle-m mb-2 text-neutral-80">{label}</label>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 shrink-0">
          <span className="body-s text-neutral-80">{toggleLabel}</span>
          <button
            type="button"
            role="switch"
            aria-checked={isChecked}
            onClick={onToggle}
            className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors duration-200
              ${isChecked ? 'bg-black' : 'bg-[#D4D4D4]'}`}
          >
            <span
              className={`pointer-events-none inline-block h-5 w-5 mt-0.5 ml-0.5 rounded-full bg-white shadow-md transition-transform duration-200
                ${isChecked ? 'translate-x-5' : 'translate-x-0'}`}
            />
          </button>
        </div>
        {children && <div className="flex-1">{children}</div>}
      </div>
      {error && !isChecked && <p className="text-error mt-1">{error}</p>}
    </div>
  )
}
